import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadingRecipients } from "../redux/actions";
import { recipientsSelector } from "../redux/selectors";
import { NonNullableRecipientsState } from "../redux/state";

export const useRecipientsState = (
  informationRequestId: string,
  itemId?: string
) => {
  const dispatch = useDispatch();

  const state = useSelector(recipientsSelector);

  const isCorrectRecordInRedux =
    state.resourceId &&
    state.resourceId.informationRequestId?.toLowerCase() === informationRequestId?.toLowerCase() &&
    state.resourceId.itemId === itemId;

  useEffect(() => {
    if (state.status !== "LOADING" && !isCorrectRecordInRedux) {
      dispatch(
        loadingRecipients({ informationRequestId, itemId })
      );
    }
  }, [
    dispatch,
    isCorrectRecordInRedux,
    informationRequestId,
    itemId,
    state,
  ]);

  return isCorrectRecordInRedux ? (state as NonNullableRecipientsState) : null;
};
